var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFloating = function SvgFloating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 21"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.558 20.558H2.443a2 2 0 0 1-2-2V5.841a2 2 0 0 1 2-2h17.115a2 2 0 0 1 2 2v12.717a2 2 0 0 1-2 2m-16.8-15.4a1 1 0 0 0-1 1v12.083a1 1 0 0 0 1 1h16.485a1 1 0 0 0 1-1V6.161a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.4 16.158H6.602a.88.88 0 1 0 0 1.76H15.4a.88.88 0 1 0 0-1.76M20.678.322H1.323a.88.88 0 1 0 0 1.76h19.355a.88.88 0 1 0 0-1.76"
  })));
};
export default SvgFloating;